export default __webpack_public_path__ + "static/fvxmHHcB-80fa646f10c84833b4d037884e92713e.svg";